import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { AccordionData, AccordionEvent, ACCORDION_EVENT } from './accordion.interface';
import { CommonModule } from '@angular/common';
import { SectionComponent } from '../section/section.component';
import { FontIconComponent } from '../font-icon/font-icon.component';

@Component({
    selector: 'finder-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SectionComponent,
        FontIconComponent
    ]
})
export class AccordionComponent implements AfterViewInit {
    @Input() data: Array<AccordionData>;
    @Input() openCategory: string;
    @Output() clickedElement: EventEmitter<AccordionEvent> = new EventEmitter();

    EVENTS = ACCORDION_EVENT;

    constructor(
        private elementRef: ElementRef,
    ) { }

    ngAfterViewInit(): void {
        // Check to see if there's a category
        this.checkForCategoryToOpen();
    }

    getElementRef(): Element {
        return this.elementRef.nativeElement;
    }

    checkForCategoryToOpen() {
        // Stop if there is no default
        if (!this.openCategory) {
            return;
        }

        // Look for the element to open
        const elm = this.getSection(this.openCategory);
        // Stop of the element doesn't exist
        if (!elm) {
            return;
        }

        elm.click();
    }

    /**
     * Emit an event to update the Map.
     *
     * @param $event
     * @param type ACCORDION_EVENT
     * @param id Section ID
     */
    clicked($event: Event, type: string, id: string) {
        $event.stopPropagation();

        let expanded = true;
        const event: AccordionEvent = {
            type,
            id,
            target: $event.currentTarget
        };

        // Check if we are collapsing or expanding the
        // section.
        if (type === this.EVENTS.CATEGORY) {
            const section = this.getSection(id);
            expanded = section.getAttribute('aria-expanded') === 'true';
        }

        // If all the sections are collapsed,
        // change the event type to tell the map
        // to show all available markers.
        if (!expanded) {
            event.type = this.EVENTS.DISPLAY_ALL;
        }

        this.clickedElement.emit(event);

        this.markPressedElement($event.currentTarget);
    }

    getSection(id): HTMLElement {
        return this.getElementRef().querySelector(`#${id}`);
    }

    private markPressedElement(element) {
        // Change the aria stats for all elements
        this.getElementRef().querySelectorAll('div.location').forEach(elm => elm.ariaPressed = 'false');

        // Mark the clicked element as pressed
        element.ariaPressed = 'true';
    }
}
